import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  min-height: 336px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
